import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {environment} from '../environments/environment';
import { Observable, throwError} from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import {Animal} from '../app/Models/animal';


@Injectable({
  providedIn: 'root'
})

export class SharedService {
  envName = environment.name;
 // readonly ApiUrl = environment.apiBaseUrl;
 readonly ApiUrl = "https://wwwx.miamidade.gov/apps/asd/animaloutcomeapi/";
  

  constructor(private http:HttpClient) { }

  getAnimals(id: string) {
    return this.http.get(this.ApiUrl + "api/animaloutcome/"+id);

   // this.http.delete(this._baseUrl);
  }
  
}
